'use client';
import { Global as Global$1 } from '@emotion/react';
import { useTheme } from '../hooks/index.mjs';
import { interpolationTheme } from '../utils/index.mjs';
import { jsx } from '@emotion/react/jsx-runtime';

// src/global/index.tsx
var Global = ({ styles }) => {
  const theme = useTheme();
  return /* @__PURE__ */ jsx(Global$1, { styles: interpolationTheme(styles, theme) });
};
var global_default = Global;

export { global_default as default };
